// 获取订单金额
// http://api.umucdn.cn/project/216/interface/api/3008
import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    type: number; // int, 类型 1. 购买（默认值） 2. 续费, 3. 增购
    account_quota: number;
    package?: string;
    base_quota?: number;
}

export interface IOutput {
    order_amount: number; // 订单金额
    original_amount: number; // 原价
    avg_amount: number; // 平均价格
    discount: number; // 折扣
}

export const getCommericalOrderAmount = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.GET_COMMERICAL_ORDER_AMOINT, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
